import React from 'react';
import { Trans } from '@lingui/react/macro';
import { Modal, ModalBody } from '@ygtechnologies/bygr-frontend-component-library';
import { Link } from 'react-router-dom';
import { Button } from '@/components/Buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import theme from './LinkToUnit.module.scss';

export const LinkToUnitFinishModal: React.FC<{}> = () => {
    const iconSize = 100;

    return (
        <Modal isOpen={true}>
            <ModalBody className={theme.finishModal}>
                <FontAwesomeIcon style={{ width: `${iconSize}px`, height: `${iconSize}px` }} icon={faCheckCircle} />
                <p>
                    <Trans>The products are now waiting for approval before they are visible to the buyer</Trans>
                </p>
                <Link to="/catalog/groups">
                    <Button color="primary">
                        <Trans>Back to Product Groups</Trans>
                    </Button>
                </Link>
            </ModalBody>
        </Modal>
    );
};
